import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const FALLBACK_LISTING_IMG =
  "https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=1200";

/** Resolve listing media URLs (proxy-relative `/api/media/...` → absolute backend). */
export function resolveMediaUrl(url) {
  if (!url) return FALLBACK_LISTING_IMG;
  if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith("data:")) {
    // Rewrite legacy direct Borough hotlinks through our proxy.
    const marker = "/v1/photos/";
    if (url.includes("borough.qwady.app") && url.includes(marker)) {
      const key = url.split(marker)[1]?.split("?")[0];
      if (key) return `${BACKEND_URL}/api/media/borough/${key}`;
    }
    return url;
  }
  if (url.startsWith("/")) return `${BACKEND_URL}${url}`;
  return url;
}

export { FALLBACK_LISTING_IMG };

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("wr_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
